module.exports = __webpack_public_path__ + "img/Breakfast_Quesadilla.116b6d2a.jpg";